/* eslint-disable max-len */
export default {
  logout: `<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="logout">
      <path
        d="M12.0002 5.83333L14.6668 8.5M14.6668 8.5L12.0002 11.1667M14.6668 8.5H6.00016M10.0002 3.30269C9.15033 2.79218 8.16366 2.5 7.11127 2.5C3.9203 2.5 1.3335 5.18629 1.3335 8.5C1.3335 11.8137 3.9203 14.5 7.11127 14.5C8.16366 14.5 9.15033 14.2078 10.0002 13.6973"
        stroke="currentColor"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"/>
    </g>
  </svg>`,
  trash: `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="trash">
        <path
          d="M10 3.75V3.25C10 2.54993 10 2.1999 9.86376 1.93251C9.74392 1.69731 9.55269 1.50608 9.31749 1.38624C9.0501 1.25 8.70007 1.25 8 1.25H7C6.29993 1.25 5.9499 1.25 5.68251 1.38624C5.44731 1.50608 5.25608 1.69731 5.13624 1.93251C5 2.1999 5 2.54993 5 3.25V3.75M6.25 7.1875V10.3125M8.75 7.1875V10.3125M1.875 3.75H13.125M11.875 3.75V10.75C11.875 11.8001 11.875 12.3251 11.6706 12.7262C11.4909 13.079 11.204 13.3659 10.8512 13.5456C10.4501 13.75 9.9251 13.75 8.875 13.75H6.125C5.0749 13.75 4.54985 13.75 4.14877 13.5456C3.79596 13.3659 3.50913 13.079 3.32936 12.7262C3.125 12.3251 3.125 11.8001 3.125 10.75V3.75"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"/>
      </g>
    </svg>`,
  chevronLeft: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="chevron-left">
        <path
          d="M9.33337 12L5.33337 8L9.33337 4"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"/>
      </g>
    </svg>`,
  plus: `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="plus">
        <path d="M8.50004 3.33398V12.6673M3.83337 8.00065H13.1667"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"/>
      </g>
    </svg>`,
  searchIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M19 19L15.5001 15.5M18 9.5C18 14.1944 14.1944 18 9.5 18C4.80558 18 1 14.1944 1 9.5C1 4.80558 4.80558 1 9.5 1C14.1944 1 18 4.80558 18 9.5Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round" 
      stroke-linejoin="round"/>
    </svg>`,
  searchLgIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"/>
    </svg>`,
  eyeClosed: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213" stroke="#4D5483" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
  eye: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z" stroke="#4D5483" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z" stroke="#4D5483" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`,
};
